"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RotatedIcon = exports.Heading = exports.DateField = exports.Container = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const colors = __importStar(require("../../../../assets/styles/colors"));
const media_1 = require("../../../../utils/media");
const Typography_1 = require("../../../atoms/Typography");
const Container = styled_components_1.default.div `
  display: flex;
  align-items: center;
  padding-bottom: ${({ $isCalendarPage, $rotated }) => $isCalendarPage && !$rotated ? "10rem" : "1.25rem"};

  @media ${media_1.media.smallDesktop} {
    justify-content: none;
  }
`;
exports.Container = Container;
const RotatedIcon = styled_components_1.default.img `
  margin-right: 10px;
  transform: ${({ $rotated }) => ($rotated ? "rotate(180deg)" : "none")};
  cursor: pointer;
`;
exports.RotatedIcon = RotatedIcon;
const Heading = (0, styled_components_1.default)(Typography_1.H1) `
  font-weight: 500;
  font-size: 22px;
  cursor: pointer;

  @media ${media_1.media.desktop} {
    display: flex;
    justify-content: space-between;
    width: 100%;
    cursor: auto;
    font-size: 28px;
  }
`;
exports.Heading = Heading;
const DateField = styled_components_1.default.div `
  display: none;

  @media ${media_1.media.desktop} {
    display: flex;
    align-items: center;
    font-size: 16px;
    color: ${colors.gray300};
    font-weight: 500;
    line-height: 1.2;

    span {
      margin: 0 0.6rem;
    }
  }
`;
exports.DateField = DateField;
